export default class Studie {

    public studie_id: number | null = null;
    public bezeichnung: string | null = null;
    public gueltig: string | null = 'j';

    constructor(data?: Partial<Studie>) {
        Object.assign(this, data);
    }
}
